import { render, staticRenderFns } from "./form-component.vue?vue&type=template&id=6c4bbd9c&"
import script from "./form-component.vue?vue&type=script&lang=js&"
export * from "./form-component.vue?vue&type=script&lang=js&"
import style0 from "./form-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports